import { render } from "./guid.vue?vue&type=template&id=0ce07d51"
import script from "./guid.vue?vue&type=script&lang=js"
export * from "./guid.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/geramyan-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__